/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Share_NotesInputs */



/**
* | output |
* | --- |
* | "Share your notes" |
*
* @param {Meeting_Report_Share_NotesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_share_notes = /** @type {((inputs?: Meeting_Report_Share_NotesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Share_NotesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deel je notities")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Partager vos notes")
	return /** @type {LocalizedString} */ ("Share your notes")
});